export default "__VITE_ASSET__DXC0pfF___"